module.exports = __webpack_public_path__ + "img/porsche-nurburgring.57d79f6b.jpg";